export enum DocumentRequestStatusEnum {
  REQUESTED = 'REQUESTED',
  READY_FOR_REVIEW = 'READY_FOR_REVIEW',
  APPROVED = 'APPROVED',
  ATTENTION = 'ATTENTION',
  UPLOADED = 'UPLOADED',
  DEFAULT = 'DEFAULT',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  PARTIALLY_UPLOADED = 'PARTIALLY_UPLOADED',

  REJECTED = 'REJECTED',
}
